module.exports = __webpack_public_path__ + "84354fa73387636617dab591c5798367.jpg";